<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-data-table :headers="headers" :items="event_type_list" dense class="elevation-1 mytable" :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Event Type</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="1" cols="12">
            </v-col>
            <v-col sm="6" md="4" cols="12">

              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add Event Type</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">

                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-autocomplete v-model="editedItem.eventType" label="Event Type"
                            :items="event_type_super_master_list" :disabled="editedIndex != -1" persistent-hint
                            :hint="editedIndex==-1?'Select Event Type :: Activity, Holiday etc':'noneditable'"
                            :filled="editedIndex==-1?false:true" :error="errorMsg.eventType?true:false"
                            :error-messages="errorMsg.eventType?'Required':''"
                            :rules="[v => !!v || 'required']"></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active?"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn color="primary darken-1" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2  v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2  v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      valid: false,
      event_type_super_master_list: null,
      overlay: false,
      errorMsg:{
        eventType:false,
      },
      snackbar_msg: "",
      // extraBreadcrumbItems: [
      //   { text: "Event Type", disabled: true, href: "" },

      // ],
      // breadcrumbClass: "breadcrumb-style1",
      color: "",
      snackbar: false,
      search:'',
      dialog: false,      
      event_type_super_master_list:null,
      headers: [
        {
          text: 'Event Type',
          align: 'left',
          sortable: false,
          value: 'eventType',
        },
        {
          text: 'Active',align: 'left',sortable: true,value: 'isactive',
        },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      event_type_list: [],
      editedIndex: -1,
      addedItem:{
        event_type_super_master_list:'',
      },
      editedItem: {
        eventTypeId: '',
        eventType: '',
        isactive:true,
      },
      defaultItem: {
        eventTypeId: '',
        eventType: '',
        isactive:true,
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Event Type' : 'Edit Event Type'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      overlay (val) {
        val = () => {
          this.overlay = false
        };
      },
    },

    // created () {
    //   this.initialize()
    // },
    mounted(){
      this.onLoad()
     },
    methods: {
    //   initialize () {
        
    //   },

      editItem (item) {
        this.editedIndex = this.event_type_list.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      onLoad(){
      this.overlay=true
      axios
      .post("/CommunicationType/eventType")
      .then(res => {
        if (res.data.msg == "200") {
          //window.alert(res.data.msg)
         
          if(this.load = true){
            this.overlay=false;
           this.event_type_list = res.data.event_type_list
          this.event_type_super_master_list=res.data.event_type_super_master_list
          }
        } else {
          window.console.log(res.data.msg)
        }
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        window.console.log(error);
      })
      .finally(()=>{ 
        'use strict';
        var overlay=false;
      });
      },
       showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    
      // deleteItem (item) {
      //   const index = this.country_master_list.indexOf(item)
      //   confirm('Are you sure you want to delete this item?') && this.country_master_list.splice(index, 1)
      // },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) 
        {
          if(this.isValidated())
         {
          axios
          .post("/CommunicationType/editEventType", this.editedItem)
          .then(res => {
            if (res.data.msg == "200") {
              //window.alert(res.data.msg)
              Object.assign(this.event_type_list[this.editedIndex], this.editedItem)
            }
             this.showSnackbar(
                  "#4caf50",
                  "Event Type Updated Successfully..."
                ); // show snackbar on success
          })
          .catch(error => {
            window.console.log(error);
          });
            this.close()
         }
        } 
        else 
        {
          //this.country_master_list.push(this.editedItem)
           axios
          .post("/CommunicationType/saveEventType", this.editedItem)
          .then(res => {
            if (res.data.status.code == "SUCCESS") {
            //window.alert(res.data.status.code)
            this.event_type_list.push(this.addedItem);
             this.showSnackbar("#4caf50", "Event Type Added Successfully!!!"); // show snackbar on success
             this.onLoad() 
            }
            else if(res.data.status.code == "NA"){
                //window.alert(res.data.status.code)
                //alert(res.data.status.message)
                this.showSnackbar("#b71c1c", "Event Type Already Present!!!"); // show snackbar on error
            }
          })
          .catch(error => {
            window.console.log(error);
          });
          this.close()
        }
      }, //save()
      isValidated(){
      if(this.editedItem.eventType)
       { 
           return true; 
       }
      else{
            if(!this.editedItem.eventType)
            {
              this.errorMsg.eventType=true
            }
           
        return false;
      }  
     }, // .....end of isValidated()
    },
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
.mytable /deep/ thead th {
      background: #0F2027;  /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2C5364, #203A43, #0F2027);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2C5364, #203A43, #0F2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0F2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>